import * as actionTypes from '../constants/actionTypes';
var initialState = {
    scrollPos: null,
    smoothScroll: false,
};
export default function overlay(state, action) {
    if (state === void 0) { state = initialState; }
    switch (action.type) {
        case actionTypes.SHOW_OVERLAY:
        case actionTypes.SHOW_HOVER_OVERLAY:
            return { scrollPos: action.scrollPos };
        case actionTypes.SET_OVERLAY_SCROLL_POS:
            return { scrollPos: action.scrollPos, smoothScroll: action.smoothScroll };
        case actionTypes.UNSET_OVERLAY_SCROLL_POS:
            return { scrollPos: null };
        default:
            return state;
    }
}
